import React, { useContext } from "react";

import styled from "@emotion/styled";

import { DataContext } from "../../../../../providers/PelletsCheckoutDataProvider";
import { isWebView } from "../../../../../utils/webViewRedirect";
import Headline from "../../../../shared/Headline";
import LinkComponent from "../../../../shared/LinkComponent";
import LoadingIndicator from "../../../../shared/LoadingIndicator";
import TextAlign from "../../../../shared/TextAlign";
import * as styles from "./style.module.scss";

const StepSuccess = () => {
    const dataContext = useContext(DataContext);
    const { loading, orderData } = dataContext.data;

    const LinkContainer = styled.div`
        margin-top: 2em;
    `;

    return (
        <section>
            {loading ? (
                <React.Fragment>
                    <Headline center>Ihre Bestellung wird übermittelt</Headline>
                    <TextAlign Component="p" align="center">
                        Haben Sie einen Moment Geduld
                    </TextAlign>
                    <LoadingIndicator />
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Headline>Vielen Dank für Ihre Bestellung</Headline>

                    {orderData !== null && (
                        <>
                            <p>
                                Ihr Auftrag ist bei uns eingegangen und wird in
                                Kürze bearbeitet. Ihre Auftragsnummer lautet{" "}
                                <strong>{orderData.order_number}</strong>.
                            </p>
                            <p>
                                Sie erhalten eine Bestellbestätigung per E-Mail.
                            </p>
                        </>
                    )}

                    <div className={styles.contact}>
                        <div className={styles.contactInfo}>
                            <strong>Ihr Pellets-Team von Hoyer</strong>
                            <br />
                            Wilhelm Hoyer B.V. & Co. KG
                            <br />
                            Rudolf-Diesel-Str.1
                            <br />
                            27374 Visselhövede
                            <br />
                            Tel.: 04262 –799979
                            <br />
                            E-Mail:{" "}
                            <a href={`mailto:pelletsonline@hoyer.de`}>
                                pelletsonline@hoyer.de
                            </a>
                        </div>
                    </div>
                    {/* Show a redirect back to calculator on webview since there is no other navigation */}
                    {isWebView() && (
                        <LinkContainer>
                            <LinkComponent
                                link={{
                                    href: "/webview/holzpellets",
                                    text: "Zurück zum Holzpellet-Rechner",
                                }}
                                color="red"
                            />
                        </LinkContainer>
                    )}
                </React.Fragment>
            )}
        </section>
    );
};

export default StepSuccess;
